import { CustomCSS, imageField, urlField, textField } from "./CustomCSS.ts";
import type { SourceProfile, OperationDefinition } from "../types.ts";
export type TemplateOptions = Pick<SourceProfile, "id" | "name" | "baseUrl" | "allowedHosts"> &
  Partial<Omit<SourceProfile, "id" | "name" | "baseUrl" | "allowedHosts">>;
export function Madara(options: TemplateOptions): SourceProfile {
  const chapters: OperationDefinition = {
    steps: [
      {
        url: "{manga.url}",
        extract: {
          kind: "html",
          selector: '.wp-manga-chapter:not(.premium-block) a[href*="/manga/"]',
          fields: { name: textField(), url: urlField() },
        },
      },
    ],
    fallbacks: [
      {
        steps: [
          {
            url: "{manga.url}/ajax/chapters/",
            method: "POST",
            referer: "{manga.url}",
            extract: {
              kind: "html",
              selector: '.wp-manga-chapter:not(.premium-block) a[href*="/manga/"]',
              fields: { name: textField(), url: urlField() },
            },
          },
        ],
      },
      {
        steps: [
          {
            url: "{manga.url}",
            capture: {
              postId: {
                selector: "#manga-chapters-holder, .manga-chapters-holder",
                attributes: ["data-id", "data-post-id"],
              },
            },
          },
          {
            url: "{baseUrl}/wp-admin/admin-ajax.php",
            method: "POST",
            referer: "{manga.url}",
            form: { action: "manga_get_chapters", manga: "{prev.postId}" },
            extract: {
              kind: "html",
              selector: '.wp-manga-chapter:not(.premium-block) a[href*="/manga/"]',
              fields: { name: textField(), url: urlField() },
            },
          },
        ],
      },
    ],
  };
  const catalog: OperationDefinition = {
    steps: [
      {
        url: "{baseUrl}/?paged={page}",
        capture: { nextUrl: urlField("a.next, .nav-previous a", false) },
        extract: {
          kind: "html",
          selector: ".page-item-detail",
          emptySelector: ".no-results",
          fields: {
            title: textField(".post-title a"),
            url: urlField(".post-title a"),
            coverUrl: imageField("img", false),
          },
        },
      },
    ],
  };
  return CustomCSS({
    schemaVersion: 1,
    template: "Madara",
    requiresSession: true,
    ui: { idMode: "path", mangaPath: "/manga/", chapterPath: "/manga/", trailingSlash: true },
    catalog,
    latest: { steps: [{ ...catalog.steps[0], url: "{baseUrl}/?post_type=wp-manga&m_orderby=new-manga&paged={page}" }] },
    ...options,
    operations: options.operations ?? {
      search: {
        steps: [
          {
            ...catalog.steps[0],
            url: "{baseUrl}/?s={query}&post_type=wp-manga&paged={page}",
            extract: {
              ...catalog.steps[0].extract!,
              selector: ".c-tabs-item__content, .page-item-detail",
            },
          },
        ],
      },
      detail: {
        steps: [
          {
            url: "{manga.url}",
            extract: {
              kind: "html",
              fields: {
                title: textField(".post-title h1, h1"),
                coverUrl: imageField(".summary_image img, .tab-summary img", false),
                description: textField(
                  ".description-summary, .summary__content, .summary-content",
                  false,
                ),
                author: textField(".author-content", false),
              },
            },
          },
        ],
      },
      chapters,
      pages: {
        steps: [
          {
            url: "{chapter.url}",
            referer: "{manga.url}",
            extract: {
              kind: "html",
              selector: ".reading-content img, .page-break img, .wp-manga-chapter-img",
              fields: { url: imageField() },
            },
          },
        ],
      },
    },
  });
}
